import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import maintenanceImg from "assets/images/maintenanceimg.svg";
import { PrimaryGradientButton } from "components/buttons";
import { Link } from "react-router-dom";

const Maintenance = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <main className="main section container">
      <div className="d-flex flex-column center-content  text-align-center justify-content-center align-items-center">
        <img src={maintenanceImg} alt="Maintenance" style={{ height: "90%" }} />

        <p className="maintenance-title">
          Oops! Our site is under construction. We’ll be back with more exciting
          products.
        </p>

        <h5 className="maintenance-subtitle" style={{ color: "black" }}>
          <span>Contact us at</span>
          <span style={{ color: "#221AFB" }}>
            {" "}
            +603 2332 6000 (Customer Support)
          </span>{" "}
          or visit
          <span style={{ color: "#221AFB" }}> alrajhibank.com.my</span> for more
          information.
        </h5>

        <div style={{ paddingTop: "64px" }}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <PrimaryGradientButton text="Back to home" />
          </Link>
        </div>
      </div>
    </main>
  );
};

export default Maintenance;
